import updateObjectStructure from './updateObjectStructure'

const createVersionUpdater = ({versions, getUpgradeFunction}) => object =>
  updateObjectStructure(object, {versions, getUpgradeFunction})

export default createVersionUpdater
